/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useState} from "react";


import dateFormat from "dateformat";


import {Col, Form, Row} from "react-bootstrap";


import MONITORY_NOTE_INTERFACE from "@Services/Application/Interfaces/MonitoryNotes/MonitoryNote";
import {MONITORY_NOTE_DATA_INTERFACE} from "@UIPages/Authenticated/MonitoryNotes/Create";


type MonitoryNoteInformationProps = {
    MONITORY_NOTE_PROCESS_TYPE: "creation" | "edition" | "submitting";
    MONITORY_NOTE: MONITORY_NOTE_INTERFACE | null;
    MONITORY_NOTE_HANDLER?(MONITORY_NOTE: MONITORY_NOTE_INTERFACE): void;
    MONITORY_NOTE_DATA?: MONITORY_NOTE_DATA_INTERFACE;
    EDITABLE?: boolean;
    LOAD_CONTENT?: boolean;
    LOAD_CONTENT_HANDLER?(STATUS: boolean): void;
};

export const MonitoryNoteInformationComponent: React.FC<MonitoryNoteInformationProps> = ({
    MONITORY_NOTE_PROCESS_TYPE = "edition",
    MONITORY_NOTE, MONITORY_NOTE_HANDLER = null, MONITORY_NOTE_DATA = null,
    EDITABLE = true,
    LOAD_CONTENT = true, LOAD_CONTENT_HANDLER
}): JSX.Element | null => {


    const [selectedFrontTruck, setSelectedFrontTruck] = useState<string>(MONITORY_NOTE?.FrontTruckRegNo || "");

    const changeSelectedFrontTruck = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedFrontTruckRegNo =  e.target.value;
        setSelectedFrontTruck(selectedFrontTruckRegNo);
        if (!!MONITORY_NOTE_HANDLER) {
            MONITORY_NOTE_HANDLER({...MONITORY_NOTE, FrontTruckRegNo: selectedFrontTruckRegNo});
        }
    };


    if (!MONITORY_NOTE || !MONITORY_NOTE?.Disps || !MONITORY_NOTE?.FrontTruckRegNo) return null;


    if (!LOAD_CONTENT) return null;


    const frontVehicleIsTank: boolean =  !!MONITORY_NOTE_DATA?.VEHICLES?.FRONT?.IsTank;


    const availableMonitoryNoteVehicles = new Set();

    if (!frontVehicleIsTank) {
        for (let monitoryNoteDisposition of MONITORY_NOTE?.Disps) {
            const {DispVehicles: dispositionVehicles} = monitoryNoteDisposition;
            if (!dispositionVehicles) continue;
            for (let dispositionVehicle of dispositionVehicles) {
                const {
                    IsTank: vehicleIsTankStatus, IsFront: vehicleIsFrontStatus, RegNo: vehicleRegistrationNumber
                } = dispositionVehicle;
                if (vehicleIsTankStatus || !vehicleIsFrontStatus) continue;
                availableMonitoryNoteVehicles.add(vehicleRegistrationNumber);
            }
        }
    }

    const monitoryNoteFrontVehicles = Array.from(availableMonitoryNoteVehicles);


    return (
        <Col xs={12} className={"monitory-note-information monitory-note-information-component"}>
            <Row className={"monitory-note-information-content"}>

                {(!!MONITORY_NOTE_DATA?.TERMINAL?.TERMINAL_NAME || !!MONITORY_NOTE?.TerminalNo) &&
	            <Col xs={12} className={"monitory-note-terminal-name"}>
		            <span>{`Baza Paliw`} {MONITORY_NOTE_DATA?.TERMINAL?.TERMINAL_NAME || MONITORY_NOTE?.TerminalNo}</span>
	            </Col>
                }

                <Col xs={12} className={"monitory-note-vehicles"}>
                    <Row className={"monitory-note-vehicles-content"}>
                        <Col xs={6} className={"front-vehicle"}>
                            <Form.Label>{`Pojazd przedni`}:</Form.Label>
                            <Form.Control as={"select"} value={selectedFrontTruck} onChange={changeSelectedFrontTruck} disabled={!(!!monitoryNoteFrontVehicles && monitoryNoteFrontVehicles?.length > 0 && MONITORY_NOTE_PROCESS_TYPE === "edition"  && EDITABLE)}>
                                {frontVehicleIsTank && <option value={MONITORY_NOTE?.FrontTruckRegNo || ""}>{MONITORY_NOTE?.FrontTruckRegNo || ""}</option>}
                                {monitoryNoteFrontVehicles.map((vehicleRegNo: any) =>
                                    <option key={vehicleRegNo} value={vehicleRegNo}>{vehicleRegNo}</option>
                                )}
                            </Form.Control>
                        </Col>
                        <Col xs={6} className={"rear-vehicle"}>
                            <Form.Label>{`Pojazd tylny`}:</Form.Label>
                            <Form.Control as={"select"} value={MONITORY_NOTE?.RearTruckRegNo || ""} disabled={true}>
                                <option value={""}>{`- brak -`}</option>
                                <option value={MONITORY_NOTE?.RearTruckRegNo || ""}>{MONITORY_NOTE?.RearTruckRegNo}</option>
                            </Form.Control>
                        </Col>
                    </Row>
                </Col>

            </Row>
        </Col>
    );

};


export default MonitoryNoteInformationComponent;
